module.exports = __webpack_public_path__ + "static/media/profile-img-default.beb688fa.png";